import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '@/shared/api/instance';
import type {
  GetPaymentUrlParams,
  PaymentStatusResponse,
  PaymentUrlResponse,
} from '../api/buyGold.types';

export const getGoldPaymentUrl = createAsyncThunk(
  'gold/getPaymentUrl',
  async ({ amount, discountId }: GetPaymentUrlParams, thunkAPI) => {
    try {
      const params = {
        amount: amount,
        ...(discountId && { discountId }),
      };

      const response = await axiosInstance.get<PaymentUrlResponse>(
        '/app/purchases/get-gold-payment-url',
        {
          params,
        },
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'Ошибка при получении ссылки для оплаты');
    }
  },
);

export const checkGoldPaymentStatus = createAsyncThunk(
  'gold/checkPaymentStatus',
  async (paymentId: string, thunkAPI) => {
    try {
      const response = await axiosInstance.get<PaymentStatusResponse>(
        '/app/validate-payments/gold',
        {
          params: { id: paymentId },
          timeout: 25000,
        },
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'Ошибка при проверке статуса платежа');
    }
  },
);
